export class StringUtil {
  public static getSafeString(value: string | undefined | null): string {
    return value ? (value as string) : ""
  }
}
